import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import YearPage from './pages/YearPage';
import ThemePage from './pages/ThemePage';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/:year" element={<YearPage />} />
        <Route path="/:year/theme/:themeId" element={<ThemePage />} />
      </Route>
    </Routes>
  );
}

export default App;
